import { useState } from "react";
import { Nav, NavLink, NavItem } from "reactstrap";
import { SearchListsProps } from "../../../types/Applications";
import { SearchItem } from "../../../data/applications/SearchResult";

// This component renders a tab navigation bar using the Nav and NavItem components. 
const SearchLists: React.FC<SearchListsProps> = ({ callbackActive, activeTabValue }) => {

  const [activeTab, setActiveTab] = useState(activeTabValue);
  const handleTab = (id: number | undefined) => {
    if (id) {
      setActiveTab(id);
      callbackActive(id);
    }
  };

  return (
    <div className="text-center">
      <Nav tabs className="search-list">
        {SearchItem.map((data, index) => (
          <NavItem className={data.navItemClass ? data.navItemClass : ""} key={index}>
            <NavLink className={activeTab === index + 1 ? "active" : ""} onClick={() => handleTab(data.id)}>
              {data.icon}
              {data.tittle}
            </NavLink>
            <div className="material-border"/>
          </NavItem>
        ))}
      </Nav>
    </div>
  );
};
export default SearchLists;